<script>
import "@/assets/scss/navbar.scss";
import Content from '@/components/templates/ContentV2.vue';
import * as role from "@/views/ms/SdiRole";
import VueFeather from 'vue-feather';
export default {
  components: {
      Content,VueFeather
    },
  data() {
    return {
      current_role: null,
      roles:[],
      user:null,
    }
  },
  provide() {
    const appData = {}
    Object.defineProperty(appData, "current_role", {
        enumerable: true,
        get: () => this.current_role,
    })

    return {
        appData,
    }
  },
  computed:{
    isLogin(){
      return this.$store.getters['auth/isAuthenticated'] && this.user ? true : false
    },
    isSuperAdmin(){
      return this.current_role ? role.isSuperAdmin([this.current_role]) : false;
    },
    isPembinaData(){
      return this.current_role ? role.isPembinaData([this.current_role]) : false;
    },
    isWalidata(){
      return this.current_role ? role.isWalidata([this.current_role])  : false;
    },
    isProdusenData(){
      return this.current_role ? role.isProdusenData([this.current_role]) : false;
    },
    canAccessUserSetting(){
      return role.isSuperAdmin(this.roles);
    },
    canAccessSdiOrganizationSetting(){
      return role.isSuperAdmin(this.roles) || role.isPembinaData(this.roles) || role.isWalidata(this.roles);
    },
  },
  mounted(){
    this.roles = this.$store.getters['auth/user'].role.slice(1,-1).split(", ").sort();
    this.user = this.$store.getters['auth/user']
    this.current_role = localStorage.getItem('msCurrentRole') === null ? this.roles[0] : localStorage.getItem('msCurrentRole');
  },
  methods:{
    roleFormatter(role){
      if(!role) return '-';
      role = role.replace('ROLE_','');
      return role.replaceAll('_',' ').toLowerCase().replace(/(^\w{1})|(\s+\w{1})/g, letter => letter.toUpperCase());
    },
    avatarNameFormatter(name){
      if(!name) return '-'
      let split = name.split(/[\s.,]/)[0].split(" ");
      return split[0].charAt(0);
    },
    changeRole(role){
      this.current_role = role;
      this.goToAccessesiblePage();
      localStorage.setItem('msCurrentRole', this.current_role);
    },
    goToAccessesiblePage(){
      let path = this.$route.path;
      if(path == '/old-sds/daftar-usulan'){
        // if(!this.isWalidata && !this.isProdusenData){
        //   this.$router.push('/old-sds');
        // }
        this.$router.push('/old-sds');
      }
      if(path == '/old-sds/daftar-pemeriksaan' || path == '/old-sds/dashboard'){
        if(!this.isPembinaData){
          this.$router.push('/old-sds');
        }
      }
    }

  }
}
</script>
<template>
  <div>
   <div id="navbar-metadata" class="navbar-project">
      <b-navbar toggleable="lg" type="dark" variant="light">
        <b-navbar-brand href="#" style="padding:3px 10px !important;font-size:14px !important">SDS</b-navbar-brand>
        <b-navbar-toggle target="nav-collapse">
          <template #default="{ expanded }">
              <b-icon v-if="expanded" icon="x"></b-icon>
              <b-icon v-else icon="list"></b-icon>
            </template>
        </b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav>
          <b-navbar-nav pills>
            <b-nav-item to="/">
              <VueFeather type="home" size="14"></VueFeather>
            </b-nav-item>
            <b-nav-item to="/old-sds" :active="$route.path == '/old-sds' ? true : false" v-if="isSuperAdmin || isPembinaData">
              <VueFeather type="grid" size="14" ></VueFeather>SDSN
            </b-nav-item>
            <b-nav-item to="/old-sds/daftar-usulan" :active="$route.path == '/old-sds/daftar-usulan' ? true : false" v-if="isSuperAdmin" >
              <VueFeather type="edit-3" size="14"></VueFeather>Daftar Usulan
            </b-nav-item>
           
            <b-nav-item to="/old-sds/daftar-pemeriksaan" :active="$route.path == '/old-sds/daftar-pemeriksaan' ? true : false" v-if="isSuperAdmin || isPembinaData">
              <VueFeather type="check-circle" size="14"></VueFeather>Pemeriksaan
            </b-nav-item>
            <b-nav-item to="/old-sds/report" :active="$route.path == '/old-sds/report' ? true : false" v-if="isSuperAdmin || isPembinaData">
              <VueFeather type="printer" size="14"></VueFeather>Report
            </b-nav-item>
             <b-nav-item to="/old-sds/dashboard" :active="$route.path == '/old-sds/dashboard' ? true : false" v-if="isSuperAdmin || isPembinaData">
              <VueFeather type="pie-chart" size="14"></VueFeather>Dashboard
            </b-nav-item>
            
            <b-nav-item to="/old-sds/panduan" :active="$route.path == '/old-sds/panduan' ? true : false" v-if="isSuperAdmin || isPembinaData">
              <VueFeather type="layout" size="14"></VueFeather>Panduan
            </b-nav-item>
          </b-navbar-nav>

          <b-navbar-nav v-if="isLogin" class="ml-auto justify-content-end align-items-center">
            <div v-if="roles.length == 1" class="text-13  text-primary">
              {{roleFormatter(current_role)}}
            </div>
            <b-dropdown v-else right size="sm" variant="logout" toggle-class="d-flex align-items-center text-primary" >
              <template #button-content>{{roleFormatter(current_role)}}</template>
              <b-dropdown-item 
                v-for="(role , index) in roles" 
                :key="index" 
                :active="role == current_role"
                @click="changeRole(role)">
                <span class="mr-2">{{roleFormatter(role)}}</span>
                <b-icon icon="check-circle-fill" class="ml-auto" v-if="role == current_role"></b-icon>
              </b-dropdown-item>
            </b-dropdown>

            <b-dropdown no-caret right size="sm" toggle-class="ml-3 d-flex align-items-center text-primary" >
              <template #button-content>
                <div class="user-avatar">{{avatarNameFormatter(user.name)}}</div>
              </template>
              <b-dropdown-group header="User">
                <b-dropdown-item>{{user.name}} </b-dropdown-item>
                <b-dropdown-item > {{user.sdiOrganization.name}}</b-dropdown-item>
                <b-dropdown-item  to="/user/change-password" v-if="user.email.split('@')[1] != 'bps.go.id'">
                  <VueFeather type="shield" size="14"></VueFeather>&nbsp; Ubah Password
                </b-dropdown-item>
              </b-dropdown-group>
              
              <b-dropdown-group header="Pengaturan" v-if="canAccessUserSetting || canAccessSdiOrganizationSetting">
                <b-dropdown-item to="/pengaturan/user" v-if="canAccessUserSetting">
                  <VueFeather type="users" size="14" ></VueFeather>&nbsp; User
                </b-dropdown-item>
                <b-dropdown-item to="/pengaturan/sdi/organization" v-if="canAccessSdiOrganizationSetting">
                  <VueFeather type="briefcase" size="14"></VueFeather>&nbsp; Organisasi SDI
                </b-dropdown-item>
              </b-dropdown-group>
              
              <b-dropdown-divider></b-dropdown-divider>
              <b-dropdown-item to="/logout"><VueFeather type="power" size="14"></VueFeather>&nbsp; Keluar</b-dropdown-item>
            </b-dropdown>
          </b-navbar-nav>

          <b-navbar-nav v-else class="ml-auto">
            <b-button
              variant="login"
              size="sm"
              type="submit"
              to="/login"
              class="btn-login"
              >Masuk</b-button
            >
          </b-navbar-nav>
        </b-collapse>
      </b-navbar>
   </div>
   <Content />
  </div>
</template>